import { useEffect, useState } from "react";

import { FocusDateParser } from "@/utils/date";

const useCountdown = (
  targetTimestamp: number,
  padWithZeros: boolean = true,
) => {
  const [countDown, setCountDown] = useState(
    targetTimestamp - FocusDateParser.now().getTime(),
  );

  useEffect(() => {
    const interval = setInterval(() => {
      const remainingTime = targetTimestamp - FocusDateParser.now().getTime();
      if (remainingTime <= 0) {
        clearInterval(interval);
        setCountDown(0);
      } else {
        setCountDown(remainingTime);
      }
    }, 1000);

    return () => clearInterval(interval);
  }, [targetTimestamp]);

  const formatter = padWithZeros
    ? (value: number) => padZeros(value, 2)
    : (value: number) => value.toString();

  return getReturnValues(countDown, formatter);
};

const getReturnValues = (
  countDown: number,
  formatter: (value: number) => string,
) => {
  // calculate time left
  const days = Math.floor(countDown / (1000 * 60 * 60 * 24));
  const hours = Math.floor(
    (countDown % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60),
  );
  const minutes = Math.floor((countDown % (1000 * 60 * 60)) / (1000 * 60));
  const seconds = Math.floor((countDown % (1000 * 60)) / 1000);

  return [
    formatter(days),
    formatter(hours),
    formatter(minutes),
    formatter(seconds),
  ];
};

function padZeros(num: number, minLength: number) {
  const numberString = num.toString();
  if (numberString.length >= minLength) return numberString;
  return "0".repeat(minLength - numberString.length) + numberString;
}

export { useCountdown };
